export const UPLOAD_STRATEGIES = {
  AZURE: 'AZURE',
  FILE_SERVICE: 'FILE_SERVICE',
};
